export default "230e2b8fea295eb9.svg"